import * as React from 'react'
import { useState } from 'react'
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarRail,
} from '../../Components/ui/sidebar'
import { Link } from 'react-router-dom'

// This is sample data.
const data = {
  navMain: [
    {
      title: 'User Section',
      url: '#',
      items: [
        {
          title: 'Plans & Create Plan',
          url: '/6fb2a4ac30ddccb8b418e27864a778dee5409a7da4c55660f49f21b8543289b4/admin/addPlan',
        },
      ],
    },
    {
      title: 'Global Section',
      url: '#',
      items: [
        // {
        //   title: 'User Chats',
        //   url: '/6fb2a4ac30ddccb8b418e27864a778dee5409a7da4c55660f49f21b8543289b4/admin/userChats',
        // },

        {
          title: 'First User Ideas',
          url: '/6fb2a4ac30ddccb8b418e27864a778dee5409a7da4c55660f49f21b8543289b4/admin/firstUserIdeas',
        },
        {
          title: 'KYC Users',
          url: '/6fb2a4ac30ddccb8b418e27864a778dee5409a7da4c55660f49f21b8543289b4/admin/kyc-users',
        },
        {
          title: 'User Holdings',
          url: '/6fb2a4ac30ddccb8b418e27864a778dee5409a7da4c55660f49f21b8543289b4/admin/userHoldings',
        },

        // {
        //   title: 'Frontend Logs',
        //   url: '/6fb2a4ac30ddccb8b418e27864a778dee5409a7da4c55660f49f21b8543289b4/admin/frontend-logs',
        // },

        {
          title: 'Refresh Data',
          url: '/6fb2a4ac30ddccb8b418e27864a778dee5409a7da4c55660f49f21b8543289b4/admin/refresh-data',
        },

        {
          title: 'SIPs Orders',
          url: '/6fb2a4ac30ddccb8b418e27864a778dee5409a7da4c55660f49f21b8543289b4/admin/sips-orders',
        },

        {
          title: 'Cheque Orders',
          url: '/6fb2a4ac30ddccb8b418e27864a778dee5409a7da4c55660f49f21b8543289b4/admin/cheque-orders',
        },

        {
          title: 'OTM Orders',
          url: '/6fb2a4ac30ddccb8b418e27864a778dee5409a7da4c55660f49f21b8543289b4/admin/otm-orders',
        },
        {
          title: 'NAV Download',
          url: '/6fb2a4ac30ddccb8b418e27864a778dee5409a7da4c55660f49f21b8543289b4/admin/nav-download',
        },
        {
          title: 'BSE Upload',
          url: '/6fb2a4ac30ddccb8b418e27864a778dee5409a7da4c55660f49f21b8543289b4/admin/bse-upload',
        },
        // {
        //   title: 'Create Mandate',
        //   url: '/6fb2a4ac30ddccb8b418e27864a778dee5409a7da4c55660f49f21b8543289b4/admin/create-mandate',
        // },

        // {
        //   title: 'One Time Through Mandate',
        //   url: '/6fb2a4ac30ddccb8b418e27864a778dee5409a7da4c55660f49f21b8543289b4/admin/oneTimeThroughMandate',
        // },
        // {
        //   title: 'User Basket Order history',
        //   url: '/6fb2a4ac30ddccb8b418e27864a778dee5409a7da4c55660f49f21b8543289b4/admin/userBasketOrderHistory',
        // },
        // {
        //   title: 'User Basket Holdings',
        //   url: '/6fb2a4ac30ddccb8b418e27864a778dee5409a7da4c55660f49f21b8543289b4/admin/userBasketHoldings',
        // },
      ],
    },
  ],
}

const ActionSidebar = ({ user, ...props }) => {
  const [activeTab, setActiveTab] = useState(data.navMain[0].items[0].url)

  const handleTabClick = (url) => {
    setActiveTab(url)
  }

  return (
    <Sidebar {...props}>
      <SidebarHeader>
        <div className='py-3 px-2'>
          <img src='/logo.svg' alt='fabits' className='h-6' />
        </div>
      </SidebarHeader>
      <SidebarContent>
        {user && (
          <div className='flex flex-col items-start space-y-2 px-4'>
            <p className='font-medium text-sm'>Role - {user?.role}</p>
            <p className='font-medium text-sm'>Status - {user?.status}</p>
            <p className='font-medium text-sm'>Email - {user?.email}</p>
          </div>
        )}

        {data.navMain.map((item) => (
          <SidebarGroup key={item.title}>
            <SidebarGroupLabel>{item.title}</SidebarGroupLabel>
            <SidebarGroupContent>
              <SidebarMenu>
                {item.items.map((subItem) => (
                  <SidebarMenuItem key={subItem.title}>
                    <SidebarMenuButton
                      asChild
                      isActive={activeTab === subItem.url}
                      className={`${activeTab === subItem.url && 'bg-primary-50'}`}
                      onClick={() => handleTabClick(subItem.url)}
                    >
                      <Link to={subItem.url}>{subItem.title}</Link>
                    </SidebarMenuButton>
                  </SidebarMenuItem>
                ))}
              </SidebarMenu>
            </SidebarGroupContent>
          </SidebarGroup>
        ))}
      </SidebarContent>
      <SidebarRail />
    </Sidebar>
  )
}

export default ActionSidebar
